__webpack_require__.p = "/typo3conf/ext/kirinus_package/Resources/Public/Library/kirinus.de-frontend/dist/";